/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AiResponseFindCustomersOfProductsDto } from '../models/ai-response-find-customers-of-products-dto';
import { AiResponseProfilesDto } from '../models/ai-response-profiles-dto';

@Injectable({
  providedIn: 'root',
})
export class AiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation aiFindCustomersOfProducts
   */
  static readonly AiFindCustomersOfProductsPath = '/ai/find-customers-of-products';

  /**
   * Search customers of product.
   *
   * Searches customers of product according to the query in natural language
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiFindCustomersOfProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiFindCustomersOfProducts$Response(params: {
    'X-On-Behalf-Of-User': string;

    /**
     * Query string in natural language
     */
    prompt: string;
    size?: number;
  }): Observable<StrictHttpResponse<Array<AiResponseFindCustomersOfProductsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AiService.AiFindCustomersOfProductsPath, 'post');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('prompt', params.prompt, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AiResponseFindCustomersOfProductsDto>>;
      })
    );
  }

  /**
   * Search customers of product.
   *
   * Searches customers of product according to the query in natural language
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `aiFindCustomersOfProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiFindCustomersOfProducts(params: {
    'X-On-Behalf-Of-User': string;

    /**
     * Query string in natural language
     */
    prompt: string;
    size?: number;
  }): Observable<Array<AiResponseFindCustomersOfProductsDto>> {

    return this.aiFindCustomersOfProducts$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AiResponseFindCustomersOfProductsDto>>) => r.body as Array<AiResponseFindCustomersOfProductsDto>)
    );
  }

  /**
   * Path part for operation aiFindProfiles
   */
  static readonly AiFindProfilesPath = '/ai/find-people-profiles';

  /**
   * Search contact profiles.
   *
   * Searches contact profiles according to the query in natural language
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiFindProfiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiFindProfiles$Response(params: {
    'X-On-Behalf-Of-User': string;

    /**
     * Query string in natural language
     */
    prompt: string;
    size?: number;
  }): Observable<StrictHttpResponse<Array<AiResponseProfilesDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AiService.AiFindProfilesPath, 'post');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('prompt', params.prompt, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AiResponseProfilesDto>>;
      })
    );
  }

  /**
   * Search contact profiles.
   *
   * Searches contact profiles according to the query in natural language
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `aiFindProfiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiFindProfiles(params: {
    'X-On-Behalf-Of-User': string;

    /**
     * Query string in natural language
     */
    prompt: string;
    size?: number;
  }): Observable<Array<AiResponseProfilesDto>> {

    return this.aiFindProfiles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AiResponseProfilesDto>>) => r.body as Array<AiResponseProfilesDto>)
    );
  }

  /**
   * Path part for operation aiFindTechStacksforCompany
   */
  static readonly AiFindTechStacksforCompanyPath = '/ai/find-techstacks-for-company';

  /**
   * Search tech stacks for a company.
   *
   * Searches stacks according to the query in natural language
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aiFindTechStacksforCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiFindTechStacksforCompany$Response(params: {
    'X-On-Behalf-Of-User': string;

    /**
     * Query string in natural language
     */
    prompt: string;
    size?: number;
  }): Observable<StrictHttpResponse<Array<AiResponseProfilesDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AiService.AiFindTechStacksforCompanyPath, 'post');
    if (params) {
      rb.header('X-On-Behalf-Of-User', params['X-On-Behalf-Of-User'], {});
      rb.query('prompt', params.prompt, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AiResponseProfilesDto>>;
      })
    );
  }

  /**
   * Search tech stacks for a company.
   *
   * Searches stacks according to the query in natural language
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `aiFindTechStacksforCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aiFindTechStacksforCompany(params: {
    'X-On-Behalf-Of-User': string;

    /**
     * Query string in natural language
     */
    prompt: string;
    size?: number;
  }): Observable<Array<AiResponseProfilesDto>> {

    return this.aiFindTechStacksforCompany$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AiResponseProfilesDto>>) => r.body as Array<AiResponseProfilesDto>)
    );
  }

}
